// extracted by mini-css-extract-plugin
export default {"columnsBoardLayout":"activities_mobile_columnsBoardLayout__AdYDd"};